import { getFollowCheckUrl, withQuery } from '@core/api'
import { httpClient } from '@core/http-client'

export const followCheck = (authors: string[], signal?: AbortSignal) => {
    return httpClient
        .get(withQuery(getFollowCheckUrl(), { ids: authors.join(',') }), { signal })
        .json<{
            [username: string]: boolean
        }>()
}
